import React from 'react';

import { View } from 'react-native';

import SvgLock from 'assets/images/svgs/Player/ico_lock.svg';

import styles from 'components/LockIcon/LockIcon.styles';

export default function LockIcon({
    size = 24,
    style,
}: {
    size?: number;
    style?: {};
}) {
    return (
        <View style={[styles.iconContainer, style]}>
            <SvgLock fill="white" width={size} height={size} />
        </View>
    );
}
